import {
  clearOAuthCodeFromUrl,
  clearOAuthSessionState,
  getOAuthCodeFromUrl,
  getOAuthRedirectUri,
  getStoredPermissionType,
  isOAuthConnectCallback,
  normalizeExchange,
} from "./exchangeOAuth";

const BOOTSTRAP_IN_FLIGHT_KEY = "oauth_bootstrap_in_flight";

const getHandledKey = (code) => `oauth_handled_${code}`;

export const isOAuthBootstrapInFlight = () =>
  sessionStorage.getItem(BOOTSTRAP_IN_FLIGHT_KEY) === "1";

export const wasOAuthCodeHandled = (code) =>
  sessionStorage.getItem(getHandledKey(code)) === "done";

const getAuthToken = () => {
  const direct = localStorage.getItem("token");
  if (direct) return direct;

  try {
    const root = localStorage.getItem("persist:root");
    if (!root) return "";
    const parsed = JSON.parse(root);
    const userSlice = JSON.parse(parsed.user || "{}");
    return userSlice.token || "";
  } catch {
    return "";
  }
};

/**
 * Fires POST users/loginWithByBit before React Router / LoginLayout can redirect.
 * Call synchronously from index.js on bundle load.
 */
export const runExchangeOAuthBootstrap = () => {
  if (!isOAuthConnectCallback()) return false;

  const code = getOAuthCodeFromUrl();
  if (!code || wasOAuthCodeHandled(code) || isOAuthBootstrapInFlight()) {
    return isOAuthBootstrapInFlight();
  }

  const token = getAuthToken();
  const exchange = normalizeExchange(localStorage.getItem("ExchangeClick"));
  const returnTo = localStorage.getItem("oauthReturnTo") || "/";
  const redirectUri = getOAuthRedirectUri();
  const permissionType = getStoredPermissionType();
  const apiBase = process.env.REACT_APP_API_BASE_URL;

  if (!apiBase) {
    console.error("exchangeOAuthBootstrap: REACT_APP_API_BASE_URL is missing");
    return false;
  }

  sessionStorage.setItem(BOOTSTRAP_IN_FLIGHT_KEY, "1");
  sessionStorage.setItem(getHandledKey(code), "pending");

  fetch(`${apiBase}users/loginWithByBit`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: token || "",
    },
    body: JSON.stringify({ code, exchange, redirectUri, permissionType }),
  })
    .then((res) => res.json())
    .then((data) => {
      sessionStorage.removeItem(BOOTSTRAP_IN_FLIGHT_KEY);

      if (!data?.status) {
        sessionStorage.removeItem(getHandledKey(code));
        console.error(
          "exchangeOAuthBootstrap: loginWithByBit failed",
          data?.message || data
        );
        return;
      }

      sessionStorage.setItem(getHandledKey(code), "done");
      clearOAuthCodeFromUrl();
      clearOAuthSessionState();
      localStorage.removeItem("AllowSocialLogin");

      const authToken = getAuthToken();
      if (authToken) {
        fetch(`${apiBase}users/index`, {
          headers: { Authorization: authToken },
        }).catch(() => {});
      }

      window.location.replace(returnTo);
    })
    .catch((error) => {
      sessionStorage.removeItem(BOOTSTRAP_IN_FLIGHT_KEY);
      sessionStorage.removeItem(getHandledKey(code));
      console.error("exchangeOAuthBootstrap: request failed", error);
    });

  return true;
};
